import { gql } from 'apollo-angular';

export const SNK_PRICE_DESCRIPTOR_FRAGMENT = gql`
  fragment SnkPriceDescriptorFragment on SnkPriceDescriptor {
    lineId
    stepId
    value
  }
`;

export const SNK_PRICE_DESCRIPTOR_CHANGED_FRAGMENT = gql`
  fragment SnkPriceDescriptorChangedFragment on SnkPriceDescriptor {
    lineId
    stepId
    value
    isChangedManually
  }
`;
